// extracted by mini-css-extract-plugin
export default {"draftChip":"fb98GFubACYl5Jt5daNz"};